(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    document.querySelectorAll('[data-agx-gallery]').forEach((gallery) => {
      const main = gallery.querySelector('[data-agx-main-image]');
      if (!main) return;

      gallery.querySelectorAll('[data-agx-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const src = thumb.dataset.agxThumb;
          if (!src) return;
          main.src = src;
          gallery.querySelectorAll('[data-agx-thumb]').forEach((item) => item.classList.remove('is-active'));
          thumb.classList.add('is-active');
        });
      });
    });

    document.querySelectorAll('[data-agx-product-form]').forEach((form) => {
      const variantSelect = form.querySelector('select[name="id"]');
      const section = form.closest('section');

      if (variantSelect && section) {
        variantSelect.addEventListener('change', () => {
          const option = variantSelect.options[variantSelect.selectedIndex];
          section.querySelectorAll('[data-agx-current-price]').forEach((node) => {
            if (option.dataset.price) node.textContent = option.dataset.price;
          });
          section.querySelectorAll('[data-agx-compare-price]').forEach((node) => {
            node.textContent = option.dataset.compare || '';
            node.hidden = !option.dataset.compare;
          });
          section.querySelectorAll('[data-agx-saving]').forEach((node) => {
            node.textContent = option.dataset.saving || '';
            node.hidden = !option.dataset.saving;
          });
        });
      }

      if (form.dataset.agxDirectCheckout !== 'true') return;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        const originalLabel = button ? button.textContent : '';

        if (button) {
          button.disabled = true;
          button.textContent = button.dataset.loadingLabel || 'Legger til …';
        }

        try {
          const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });

          if (!response.ok) throw new Error('Cart request failed');
          window.location.assign('/checkout');
        } catch (error) {
          form.submit();
        } finally {
          if (button) {
            button.disabled = false;
            button.textContent = originalLabel;
          }
        }
      });
    });

    const sticky = document.querySelector('[data-agx-mobile-buy]');
    const order = document.querySelector('#agx-order');

    if (sticky && order && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => sticky.classList.toggle('is-visible', !entry.isIntersecting),
        { threshold: 0.15 }
      );
      observer.observe(order);
    }

    document.querySelectorAll('[data-agx-scroll-order]').forEach((button) => {
      button.addEventListener('click', (event) => {
        if (!order) return;
        event.preventDefault();
        order.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  });
})();
